import { axiosProvider } from '@/app/core/axios';
import { UserAcceptanceApiResponse, NewUserAcceptance } from '@ssar-app/domain';

export const post = (
  userAcceptance: NewUserAcceptance,
): Promise<UserAcceptanceApiResponse> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<UserAcceptanceApiResponse>(`/user/acceptance`, userAcceptance)
      .then((response) => {
        if (response) {
          const { data } = response;
          resolve(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
